import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://www.mmediacorp.com";

const ROUTES = {
  "/": {
    title: "M Media Corp | Private Media House for Celebrities, Founders & Public Figures — Meghan Amaral",
    description:
      "M Media Corp is an exclusive, by-referral private media house founded by Meghan Amaral. Trusted by celebrities, entertainers, executives, public figures and political leaders for editorial branding, PR, and film & television production.",
  },
  "/about": {
    title: "Meghan Amaral | Founder & CEO of M Media Corp — Celebrity Media Strategist",
    description:
      "Meghan Amaral is the founder and CEO of M Media Corp — a celebrity media strategist and executive producer building the public presence of high-profile founders, entertainers, executives and public figures from Newport Beach, California.",
  },
  "/services": {
    title: "Elite Media Services | PR, Editorial, Film & Television — M Media Corp",
    description:
      "Full-house media services for high-profile clients: celebrity PR, editorial branding, cinema-grade production, film & television projects, red-carpet moments, talent, events and app development. By referral.",
  },
  "/studio": {
    title: "The Studio | Courses, Books & Masterclasses by M Media Corp",
    description:
      "The M Media Studio — the same frameworks used with celebrity and executive clients, distilled into books, courses and masterclasses. Instant access in your private library.",
  },
  "/matter": {
    title: "M Matter | Get Your Idea's M Score™ — Neuro-Marketing by M Media Corp",
    description:
      "Type your content or app idea and watch the audience brain respond. M Matter maps the neural activation of your idea and returns your M Score™ — the neuro-editorial instrument by M Media Corp.",
  },
  "/journal": {
    title: "The Journal | Editorial Insights from M Media Corp",
    description:
      "Editorial dispatches from inside a private media house — branding, psychology, celebrity media strategy and the craft of public presence, by M Media Corp.",
  },
  "/apply": {
    title: "Apply for Representation | M Media Corp — By Referral",
    description:
      "M Media Corp accepts a limited number of clients each year. Apply for consideration to join a private roster of founders, entertainers, executives and public figures.",
  },
  "/contact": {
    title: "Contact | M Media Corp — Newport Beach",
    description:
      "Reach M Media Corp, the private media house in Newport Beach trusted by celebrities, executives and public figures. By referral.",
  },
  "/give": {
    title: "Giveback | Philanthropy at M Media Corp",
    description:
      "Giving is part of the house. M Media Corp dedicates work and proceeds to charitable causes chosen by our clients and team.",
  },
  "/careers": {
    title: "Careers | Join M Media Corp",
    description:
      "Work inside a private media house serving high-profile clients. Explore open roles at M Media Corp in Newport Beach and remote.",
  },
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta =
      ROUTES[pathname] ||
      (pathname.startsWith("/journal/")
        ? { title: "The Journal | M Media Corp", description: ROUTES["/journal"].description }
        : pathname.startsWith("/studio/")
        ? { title: "The Studio | M Media Corp", description: ROUTES["/studio"].description }
        : ROUTES["/"]);
    document.title = meta.title;
    upsertMeta("name", "description", meta.description);
    upsertMeta("property", "og:title", meta.title);
    upsertMeta("property", "og:description", meta.description);
    upsertMeta("property", "og:url", `${BASE}${pathname}`);
    upsertMeta("name", "twitter:title", meta.title);
    upsertMeta("name", "twitter:description", meta.description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE}${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);
  return null;
}
